import type { FlattenSimpleInterpolation } from 'styled-components'
import { css } from 'styled-components'

import { createMixin } from '@vfuk/core-mixins'

import type { Animation } from './animations.types'

const fadeOut: Animation = {
  animation: createMixin(
    (): FlattenSimpleInterpolation => css`
      @keyframes fadeOut {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    `,
  ) as Animation['animation'],
  config: {
    duration: 150,
  },
}

export default fadeOut
